<page-toolbar [pageActions]="pageActions" title="{{'myUsers.' + (isCreate ? 'createTitle' : 'editTitle') | translate}}{{getTitle()}}"></page-toolbar>

<page-content>
  <mat-card appearance="outlined" *ngIf="!!profile">
    <div class="half-width-inputs">
      <smart-input [model]="profile" key="email" translationPrefix="myUsers"></smart-input>
      <div class="or">/</div>
      <smart-input [model]="profile" key="mobile" translationPrefix="myUsers"></smart-input>
    </div>
    <smart-input [model]="profile" key="channel" translationPrefix="myUsers.channel"></smart-input>
    <div class="half-width-inputs">
      <smart-input [model]="profile" key="firstName" translationPrefix="myUsers"></smart-input>
      <smart-input [model]="profile" key="lastName" translationPrefix="myUsers"></smart-input>
    </div>
    <div class="half-width-inputs">
      <smart-input [model]="profile" key="isDeskWorker" translationPrefix="myUsers"></smart-input>
      <div class="label-field">
        <mat-form-field class="example-full-width">
          <input id="labelInput" #autocompleteInput matInput placeholder="Labels" [matAutocomplete]="auto" [formControl]="stateCtrl" (keyup.enter)="addLabel($event)">
          <mat-autocomplete #auto="matAutocomplete">
            <mat-option (onSelectionChange)="addExistingLabel(label)" *ngFor="let label of filteredLabels" [value]="label.title">{{label.title}}</mat-option>
          </mat-autocomplete>
        </mat-form-field>

        <div class="labels">
          <div *ngFor="let label of labels" class="label" [class.visible]="profile?.labelIds?.includes(label._id)"
               [style.background-color]="'rgba(' + getRgba(label.color) + ', 0.75)'">
            <span>{{label.title}}</span>
            <mat-icon (click)="removeLabel(label)">close</mat-icon>
          </div>
        </div>
      </div>
    </div>


    <div *ngIf="errorMessage?.message" class="error-message">{{'myUsers.errors.' + errorMessage?.message | translate}}</div>
  </mat-card>

  <mat-card appearance="outlined" *ngIf="!!additionalProfileData" class="additional-profile-data">
    <mat-card-title>{{'myUsers.additionalProfileData' | translate}}</mat-card-title>
    <div class="container">
      <ng-container *ngFor="let key of additionalFieldKeys">
        <smart-input [model]="additionalProfileData.data" [key]="key" [fieldConfig]="additionalFieldConfig[key]"></smart-input>
      </ng-container>
    </div>
  </mat-card>

  <div *ngIf="!isCreate" class="table">
    <data-table (remove)="deleteGroup($event)" [columns]="columns" [dataProviderParams]="params"
                    [dataProvider]="groupHasFrontProfileService"
                    [hideSearch]="true" [title]="'myUsers.groupAssignment' | translate"></data-table>
    <button (click)="addToGroup()" class="add-button" color="primary" mat-mini-fab>
      <mat-icon class="mat-24">add</mat-icon>
    </button>
  </div>

  <div class="button-right-container">
    <button (click)="saveUser()" class="ibexfusion-raised-button" mat-button>{{'general.save' | translate}}</button>
  </div>
</page-content>
